import { render, staticRenderFns } from "./RequiredTextField.vue?vue&type=template&id=80521496"
import script from "./RequiredTextField.vue?vue&type=script&lang=js"
export * from "./RequiredTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports